import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { normalizeBookshelfItem } from '../lib/bookshelf';

export function useBookshelf() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchItems = useCallback(async () => {
    const { data, error: err } = await supabase.rpc('get_bookshelf');
    if (err) {
      console.error('get_bookshelf:', err);
      setError(true);
      return;
    }
    setError(false);
    setItems((data ?? []).map(normalizeBookshelfItem));
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchItems().finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [fetchItems]);

  return { items, loading, error, refresh: fetchItems };
}
